import React from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardImage,
} from "mdb-react-ui-kit";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "./CardListGrid.css";

export class CardListGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: true,
      columnSize: props.columnSize ? props.columnSize : 4,
      data: props.data,
      expandImageOnHover: props.expandImageOnHover !== false,
      uniformCards: props.uniformCards === true,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (prevProps.expandImageOnHover !== this.props.expandImageOnHover) {
      this.setState({ expandImageOnHover: this.props.expandImageOnHover !== false });
    }

    if (prevProps.uniformCards !== this.props.uniformCards) {
      this.setState({ uniformCards: this.props.uniformCards === true });
    }
  }

  handleButtonClick(event) {
    if (event) {
      this.props.onAction(event);
    }
  }

  render() {
    return (
      <MDBContainer>
        <div className="mt-5">
          <Container className="container-scroll">
            <Row xs={1} sm={1} md={1} lg={2} xl={3}>
              {this.state.data.map((card, index) => (
                <div className="mb-5" key={index}>
                  <Col>
                    <MDBCard className={this.state.uniformCards ? "clg-card clg-card--uniform" : "clg-card"}>
                      <div className={`image-viewer${this.state.expandImageOnHover ? " image-viewer--expand-on-hover" : ""}${this.state.uniformCards ? " image-viewer--uniform" : ""}`}>
                        <div className="image-viwer-container">
                          {card.appImg ? (
                            <MDBBtn
                              disabled={!card.enabled}
                              onClick={() => this.handleButtonClick(card)}
                            >
                              <MDBCardImage
                                src={card.appImg}
                                position="top"
                                alt={card.titulo || card.nombre || "app"}
                              />
                            </MDBBtn>
                          ) : (
                            <MDBBtn
                              className="clg-image-placeholder-btn"
                              disabled={!card.enabled}
                              onClick={() => this.handleButtonClick(card)}
                            >
                              <div className="clg-image-placeholder">Sin imagen</div>
                            </MDBBtn>
                          )}
                        </div>
                      </div>
                      {card ? (
                        <MDBCardBody className={this.state.uniformCards ? "clg-card-body--uniform" : ""}>
                          {card.titulo ? (
                            <MDBCardTitle>{card.titulo}</MDBCardTitle>
                          ) : (
                            <></>
                          )}
                          {card.descripcion ? (
                            <MDBCardText>{card.descripcion}</MDBCardText>
                          ) : (
                            <></>
                          )}
                          {card.nombre ? (
                            <MDBBtn
                              className={this.state.uniformCards ? "mt-auto" : ""}
                              disabled={!card.enabled}
                              onClick={() => this.handleButtonClick(card)}
                            >
                              {card.buttonName}
                            </MDBBtn>
                          ) : (
                            <></>
                          )}
                        </MDBCardBody>
                      ) : (
                        <></>
                      )}
                    </MDBCard>
                  </Col>
                </div>
              ))}
            </Row>
          </Container>
        </div>
      </MDBContainer>
    );
  }
}
